import { queryKeyPrefix } from 'src/features/tanStackQuery/queryKeyPrefix'

const prefix = queryKeyPrefix.productMaster

export const queryKeys = {
  masterFieldDefs: (masterUuid: string) => [
    ...prefix,
    'masterFieldDefs',
    masterUuid,
  ],
  masterLatestBatchJobStatus: (masterUuid: string) => [
    ...prefix,
    'masterLatestBatchJobStatus',
    masterUuid,
  ],
}
